import { render } from "./productDetailed.vue?vue&type=template&id=0d86bbba&scoped=true"
import script from "./productDetailed.vue?vue&type=script&lang=js"
export * from "./productDetailed.vue?vue&type=script&lang=js"

import "./productDetailed.vue?vue&type=style&index=0&id=0d86bbba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d86bbba"]])

export default __exports__